<div class="share-catalog-container">
    <div class="w-full max-md:max-w-full">
        <header class="header">
            <div class="icon-container">
                <img src="../../../assets/icones/tick.svg" class="icon"
                    alt="{{ 'Catalogs.share_catalog.share_catalog_alt' | translate }}" />
            </div>
            <h1 class="title">
                {{ 'Catalogs.share_catalog.share_your_catalog_updates' | translate }}
            </h1>
            <button class="close-button" (click)="handleCancel()">
                <img src="../../../assets/icones/exit.svg"
                    alt="{{ 'common.close' | translate }}" />
            </button>
        </header>

        <p class="description">
            {{ 'Catalogs.share_catalog.notify_customers_about_catalog' | translate }}
        </p>
        <div *ngIf="errorMessage" class="error-message">
            {{ errorMessage }}
        </div>

        <div class="locations-container">
            <div class="toolbar">
            <button *appHasPermission="submitPermission()" (click)="toggleAll()" class="select-all-button" type="button">
                <input
                type="checkbox"
                [checked]="isAllSelected"
                [indeterminate]="isIndeterminate"
                readonly
                class="hidden-checkbox"
                />
                <img *ngIf="isAllSelected" src="../../../assets/icones/filledTick.svg" alt="Checked" />
                <img *ngIf="!isAllSelected && isIndeterminate" src="../../../assets/icones/indeterminate.svg" alt="Indeterminate" />
                <img *ngIf="!isAllSelected && !isIndeterminate" src="../../../assets/icones/checkbox.svg" alt="Unchecked" />
                <span>{{ 'Catalogs.share_catalog.select_all' | translate }}</span>
            </button>

            <div class="search-container">
                <input
                type="text"
                placeholder="{{ 'Catalogs.share_catalog.search_for_locations' | translate }}"
                [(ngModel)]="searchTerm"
                class="search-input"
                />
                <img
                src="../../../assets/icones/searchloop.svg"
                class="custom-loop"
                alt="{{ 'common.search' | translate }}"
                />
            </div>

            <div class="selected-count">
                {{ selectedLocations.length }} {{ 'Catalogs.share_catalog.selected' | translate }}
            </div>
            </div>


            <div *ngIf="!locationsLoaded" class="loading-indicator">
                {{ 'Catalogs.share_catalog.loading_locations' | translate }}
            </div>

            <div *ngIf="locationsLoaded" class="locations-list">
                <div *ngFor="let location of filteredLocations" class="location-item" role="listitem" [class.disabled]="!locationHasContactsWithEmails(location)">
                    <img [src]="selectedLocations.includes(location.id!) && locationHasContactsWithEmails(location) ? '../../../assets/icones/filledTick.svg' : '../../../assets/icones/checkbox.svg'"
                        [alt]="selectedLocations.includes(location.id!) ? ('Catalogs.share_catalog.selected' | translate) : ('Catalogs.share_catalog.not_selected' | translate)"
                        role="checkbox" [attr.aria-checked]="selectedLocations.includes(location.id!) && locationHasContactsWithEmails(location)"
                        (click)="toggleLocation(location)" />
                    <div class="location-details">
                        <div class="location-name-container">
                            <div class="location-name">
                                {{ location.name }}
                            </div>
                            <div *ngIf="location.is_main" class="new-label">
                                {{ 'Catalogs.share_catalog.main' | translate }}
                            </div>
                        </div>
                        <div class="location-address">
                            {{ location.apartment || '' }}
                            <span *ngIf="location.city">, {{ location.city }}</span>
                            <span *ngIf="location.country">, {{ location.country.name }}</span>
                        </div>
                        <div class="location-address">
                            <span *ngIf="!locationHasContactsWithEmails(location)">{{ 'Catalogs.share_catalog.no_emails' | translate }}</span>
                        </div>
                    </div>
                    <div class="source-container">
                        <div class="source-icon">
                            <img src="assets/icones/company-icon.svg" class="icon"
                                [alt]="(location.company_name || ('Catalogs.share_catalog.company' | translate)) + ' icon'"
                                onerror="this.src='../../../assets/icones/company-icon.svg'" />
                        </div>
                        <div class="source-name">
                            {{ location.company_name || ('Catalogs.share_catalog.company' | translate) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="attachment-container">
            <img src="../../../assets/icones/attachedfile.svg"
                alt="{{ 'Catalogs.share_catalog.attachment' | translate }}" />
            <div class="attachment-description">
                <div class="attachment-title">
                    {{ 'Catalogs.share_catalog.attach_excel_file' | translate }}
                </div>
                <div class="attachment-subtitle">
            {{ isAttachmentEnabled
                ? ('Catalogs.share_catalog.excel_file_note_true' | translate)
                : ('Catalogs.share_catalog.excel_file_note' | translate) }}
                </div>

            </div>
            <button *appHasPermission="submitPermission()" (click)="isAttachmentEnabled = !isAttachmentEnabled"
                [class]="'attachment-toggle ' + (isAttachmentEnabled ? 'enabled' : 'disabled')" role="switch"
                [attr.aria-checked]="isAttachmentEnabled">
                <div [class]="'toggle-slider ' + (isAttachmentEnabled ? 'enabled' : 'disabled')"></div>
            </button>
        </div>

        <div class="alert-container" role="alert">
            <img src="../../../assets/icones/info-blue.svg"
                alt="{{ 'common.info' | translate }}" />
            <div class="alert-message">
                {{ 'Catalogs.share_catalog.automatic_email_note' | translate }}
            </div>
        </div>
    </div>

    <div class="button-container">
        <button (click)="handleCancel()" class="cancel-button" [disabled]="(isLoading$ | async)">
            {{ 'Catalogs.share_catalog.dont_notify' | translate }}
        </button>
        <button *appHasPermission="submitPermission()" (click)="handleNotify()" class="notify-button" [class.disabled]="(isLoading$ | async) || selectedLocations.length === 0"
            [disabled]="(isLoading$ | async) || selectedLocations.length === 0">
            <span *ngIf="!(isLoading$ | async)">{{ 'Catalogs.share_catalog.notify' | translate }} {{
                selectedLocations.length
                }} {{ selectedLocations.length !== 1 ? ('Catalogs.share_catalog.customers' | translate) :
                ('Catalogs.share_catalog.customer' | translate) }}</span>
            <span *ngIf="(isLoading$ | async)">{{ 'Catalogs.share_catalog.sending' | translate }}</span>
            <img *ngIf="!(isLoading$ | async)" src="../../../assets/icones/spinner.svg" class="icon" alt="" />
        </button>
    </div>
</div>
